interface LogoType {
    width?: string
    height?: string
}
const Logo = ({width = 'w-12', height = 'h-12'} : LogoType) => {
    return (<img src="/aihn-logo.svg" alt="logo" className={`${width} ${height}`}/>);
}

export default Logo